import React, { useState } from 'react';

// A one-time password with a copy button. Retyping one of these by hand off
// somebody else's screen is where first logins go wrong, so copying is the
// path of least resistance; the code itself is select-all for browsers that
// don't expose the clipboard API.
const PasswordChip = ({ password, className = '' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <code className="bg-gray-700 px-2 py-1 rounded text-xs font-mono text-purple-300 select-all tracking-wider">
        {password}
      </code>
      <button
        type="button"
        onClick={handleCopy}
        className="bg-purple-500/15 hover:bg-purple-500/30 text-purple-200 border border-purple-500/30 px-2 py-1 rounded text-xs font-medium"
      >
        {copied ? 'Copied' : 'Copy'}
      </button>
    </span>
  );
};

export default PasswordChip;
